export enum Limit {
	ResourcesDialog = 20,
}

export enum LimitFeatureId {
	CalendarIntegration = 'booking_calendar',
	MultiResources = 'booking_multi',
	NotificationsSettings = 'booking_notifications_settings',
	Overbooking = 'booking_overbooking',
	Waitlist = 'booking_waitlist',
	MultidayBooking = 'booking_long',
}
